<div class="cet-selectable-item-container" [class.selected]="selected">
  <div class="selectable-content">
    <ng-content></ng-content>
  </div>
  <div class="selectable-circle" *ngIf="showBubble">
    <div class="selected"></div>
  </div>
</div>
